import { useInternationalization } from "@progress/kendo-react-intl";
import { NumberFormatOptions } from '@progress/kendo-react-intl';
import { kendoCurrencyDefaultFormat, kendoNumberDefaultFormat, kendoCurrencyLowPresitionDefaultFormat } from "appConstants";

export default function useFormatterService() {
    const intl = useInternationalization();

    const quantityFormatOptions: NumberFormatOptions = {
        style: "decimal",
        maximumFractionDigits: 8
    };

    const currencyFormatOptions: NumberFormatOptions = kendoCurrencyDefaultFormat;
    const priceFormatOptions: NumberFormatOptions = kendoCurrencyLowPresitionDefaultFormat;

    function currencyFormat(num: number | undefined, format: NumberFormatOptions | undefined = kendoCurrencyDefaultFormat): string {
        var result = num !== undefined ? intl.formatNumber(num, format) : '';
        return result != 'NaN' ? result : '';
    }

    function quantityFormat(num: number | undefined, format: NumberFormatOptions | undefined = kendoNumberDefaultFormat): string {
        var result = num !== undefined ? intl.formatNumber(num, format || quantityFormatOptions) : '';
        return result;
    }

    function priceFormat(num: number | undefined, format: NumberFormatOptions | undefined = kendoCurrencyLowPresitionDefaultFormat): string {
        var result = num !== undefined ? intl.formatNumber(num, format || priceFormatOptions) : '';
        return result;
    }

    return {
        currencyFormat,
        quantityFormat,
        priceFormat,
        quantityFormatOptions,
        currencyFormatOptions,
        priceFormatOptions
    };
}